var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.hero.client?'h-auto mb-200':'',attrs:{"id":"hero"}},[_c('nav-bar'),_c('head-bar',{attrs:{"header":_vm.header,"hero":_vm.hero}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }